import { useContext } from "react";
import { LangContext } from "../../context/LangContext";

import "./style.css"

function Paging({ data, page, setPage }) {
    const { translations } = useContext(LangContext);

    return (
        <div className="paging">
            <button onClick={() => setPage(page !== 0 ? page - 1 : page)}>
                {'<- '}
                <span>{translations.return}</span>
                {' --'}
            </button>

            <span className='counter'>( {page + 1} / {data.length} )</span>

            <button onClick={() => setPage(page !== data.length - 1 ? page + 1 : page)}>
                {'-- '}
                <span>{translations.next}</span>
                {' ->'}
            </button>
        </div>
    )
}

export default Paging;